export default "__VITE_ASSET__DsOUoDHQ__"